import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import React from 'react';

import { useAuth } from '@/shared/contexts/AuthContext';
import useModeratorCommunities from '@/hooks/useModeratorCommunities';

import ProtectedRoutes from './ProtectedRoutes';

/**
 * Route guard for community moderators. Wraps ProtectedRoutes (authentication +
 * profile check) and allows access if the user is either a site admin OR has at
 * least one active moderator membership. Non-moderators are redirected to /dashboard.
 *
 * Site admins bypass the moderator check so they can also visit /moderator if needed,
 * though in practice they use /admin.
 */
const ModeratorRoutes = ({ children }) => {
    const { isAdmin, profileLoading } = useAuth();
    const { isModerator, loading: moderatorLoading } =
        useModeratorCommunities();

    const isLoading = profileLoading || moderatorLoading;

    return (
        <ProtectedRoutes>
            {isLoading ? (
                <div className="d-flex justify-content-center p-5">
                    <Spinner animation="border" variant="primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : !isAdmin && !isModerator ? (
                <Navigate to="/dashboard" replace />
            ) : (
                children
            )}
        </ProtectedRoutes>
    );
};

ModeratorRoutes.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ModeratorRoutes;
